
import axiosInstance from '@/lib/axios';
import { Notification } from '../types/notification.types';

export const getNotifications = async (): Promise<Notification[]> => {
  const response = await axiosInstance.get('/notifications');
  return response.data.data.notifications;
};

export const markAsRead = async (id: string): Promise<void> => {
  await axiosInstance.patch(`/notifications/${id}/read`);
};
